document.addEventListener('click', function(event) {
  // Check if the clicked element has the class 'form-sheet-submit-btn'
  // alert('hii');
  if (event.target.classList.contains('form-sheet-submit-btn')) {
    const newsLetterInputs = document.querySelectorAll('.newsletter-form__field-wrapper .footer-newsletter-input');
    const pincode = newsLetterInputs[0].value.trim();
    const phone = newsLetterInputs[1].value.trim();
    const errorMsg = document.querySelector('.error-message-text');

    const isValidPincode = /^\d{6}$/.test(pincode);
    const isValidPhone = /^\d{10}$/.test(phone);

    if (!isValidPincode) {
      errorMsg.innerHTML = 'Please enter a valid 6-digit pincode.';
      return; // Stop further execution
    }

    if (!isValidPhone) {
      errorMsg.innerHTML = 'Please enter a valid 10-digit phone number.';
      return; // Stop further execution
    }

    let currentCollectionHandle = document.body.dataset.collectionHandle;
    let productCategory = '';
    if(currentCollectionHandle) {
        if (currentCollectionHandle === 'sofas'){
            productCategory = 'Elite Sofa';
        } 
    }

    fetch("https://apis.thesleepcompany.in/lead/datafeed", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
          pincode: pincode,
          phone: phone,
          source: "Newsletter Community",
          lead_status: "Tier 1",
          activity_source: "Newsletter Community",
          activity_note: pincode,
          ...(productCategory && { product_type: productCategory }),  // Only include if productCategory is not empty
          ...(productCategory && { mx_custom_4: productCategory }),
          is_web_engage_event: true,
          web_engage_data: {
              product_category: productCategory, 
              pincode: pincode,
              phone: phone,
          },
      }),
    })

    gaEvent('send_my_discount_code', ['send_my_discount_code', '',pincode,`+91${phone}`,'',''], false);
  }
});